import {createBrowserRouter, createRoutesFromElements, Route, RouterProvider} from "react-router-dom"
import {Home,About,SayHi,NotFound, Root} from "./Default"
import './App.css';

function App() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route path="/" element={<Root></Root>}>
                <Route path="/" element={<Home />} />,
                <Route path="/about" element={<About />} />,
                <Route path="/sayhi" element={<SayHi />} />,
                
                <Route path='*' element={<NotFound></NotFound>} ></Route>
      </Route>
    
      )
  )
  return (
    <RouterProvider router={router}></RouterProvider>
        
  );
}

export default App;
